import { pages } from '../../../data';

const pagesFunc = (state = pages) => state;

export default pagesFunc;